import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Browser } from '@capacitor/browser';

@Injectable({
  providedIn: 'root'
})
export class LinkHandlerService {

  private rootDomain = window.location.origin; // the domain of your Angular PWA

  constructor(private router: Router) {}

  async open(url: string) {
    // Check if absolute URL
    const isAbsolute = /^https?:\/\//i.test(url);

    if (!isAbsolute) {
      // Relative → always internal navigation
      this.router.navigate([url]);
      return;
    }

    // Absolute but internal domain
    if (url.startsWith(this.rootDomain)) {
      const relative = url.replace(this.rootDomain, '');
      this.router.navigate([relative]);
      return;
    }

    // External URL → open using Capacitor Browser
    await Browser.open({ url });
  }
}
